require('./dist/angular-sidebarjs.js');
module.exports = 'ngSidebarJS';



//////////////////
// WEBPACK FOOTER
// ./~/angular-sidebarjs/index.js
// module id = 284
// module chunks = 0